import React from 'react';
import { Typography } from 'antd';
import { Colors, FontSize } from '@common/tokens';
import { Divider } from '@common/components/divider';

const { Title } = Typography;

type Props = {
  title?: string | JSX.Element;
  header?: JSX.Element;
  className?: string;
};

export const ContentContainer = ({
  title,
  header,
  className,
  children,
}: React.PropsWithChildren<Props>) => (
  <>
    <div className={`wk-content-container ${className}`}>
      <header>
        {title && <Title>{title}</Title>}
        {header && (
          <div className="content-container__header-slot">{header}</div>
        )}
      </header>
      <Divider />
      <main>{children}</main>
    </div>
    <style jsx>{`
      .wk-content-container {
        background-color: ${Colors.elmHyperlight};
        border-radius: 8px;
        font-size: ${FontSize.md};
      }

      .wk-content-container > header,
      .wk-content-container > main {
        padding: 24px;
      }

      .wk-content-container :global(h1.ant-typography) {
        font-size: ${FontSize['4xl']};
        ${!header ? 'margin: 0;' : ''}
      }

      .wk-content-container :global(h2.ant-typography) {
        font-size: 22px;
      }

      .wk-content-container :global(h3.ant-typography) {
        font-size: ${FontSize.md};
        font-weight: 800;
      }
    `}</style>
  </>
);
